<template>
  <div class="finStrategy">
    <div v-if="$route.name === 'finStrategy'">
      <fin-content-section>
        <template>
          <fin-goals/>
        </template>
      </fin-content-section>
      <fin-content-section class="py-12"
                           elevated>
        <template>
          <fin-strategy-finder :tools="tools"
                               :community="community"/>
        </template>
      </fin-content-section>
    </div>

    <router-view v-else/>
  </div>
</template>

<script>
import FinGoals from '@/components/pages/finStrategy/Goals'
import FinStrategyFinder from '@/components/pages/finStrategy/StrategyFinder'
import FinContentSection from '@/components/pages/ContentSection'

export default {
  name: 'finStrategy',
  components: {
    FinContentSection,
    FinGoals,
    FinStrategyFinder
  },
  props: {
    origin: {
      type: String
    }
  },
  data() {
    return {
      debug: true,
      tools: [
        {
          name: 'Alle Aktien-Strategien',
          description: 'Du weißt wonach du suchst? Dann wähle deine Strategie direkt aus.',
          link: 'finStrategy_list_shares',
          id: 'all-strategys-row'
        },
        {
          name: 'Alle ETF-Strategien',
          description: 'Du weißt wonach du suchst? Dann wähle deine Strategie direkt aus.',
          link: 'finStrategy_list_etfs'
        },
        {
          name: 'finDeveloper',
          description: 'Du bist bereits ein Investmentprofi? Dann entwickle dein eigenes Modell zu deiner Anlagestrategie.',
          link: '#',
          buttonDisabled: true
        },
        {
          name: 'ETF-Analyzer',
          description: 'Du willst mehr über einen ETF herausfinden? Dann untersuche seine Kennzahlen.',
          link: '#',
          buttonDisabled: true
        }
      ],
      community: [
        {
          title: 'Aktien',
          img: 'shares',
          imgButtonLink: '#',
          communityRanking: [
            {
              nr: 1,
              title: 'Dividend Dogs',
              userCount: 200
            },
            {
              nr: 2,
              title: 'Graham‘s defensiver Investor​',
              userCount: 150
            },
            {
              nr: 3,
              title: 'Kleine Titanen – Tiny Titans',
              userCount: 185
            }
          ],
          communityRankingMoreLink: '#'
        },
        {
          title: 'ETF',
          img: 'etfs',
          imgButtonLink: '#',
          communityRanking: [
            {
              nr: 1,
              title: 'ETF Unternehmensanleihen (dynamisch)',
              userCount: 195
            },
            {
              nr: 2,
              title: 'ETF Rohstoffe (konservativ)',
              userCount: 125
            },
            {
              nr: 3,
              title: 'ETF Staatsanleihen (basis)',
              userCount: 150
            }
          ],
          communityRankingMoreLink: '#'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
